import * as React from 'react';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { botoxColors } from '../../../designSystem/colors/color';
import { Flex, FlexItem } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Icon, iconName } from '../../../designSystem/icons/Icons';
import { Small } from '../../../designSystem/typography/Body';
import { H3 } from '../../../designSystem/typography/Heading';

type DashboardCardContentProps = {
    title: string;
    activityStatus: string;
    activityLink: string;
    activityTitle: string;
    createNew?: boolean;
    icon: iconName;
}

export function DashboardCardContent(props: DashboardCardContentProps ): JSX.Element {
    return (
        <Flex flexDirection="column" gap={16} style={{ minHeight: '200px' }} justifyContent="space-between">
            <Flex flexDirection="column" gap={4}>
                <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
                    <H3>{props.title}</H3>
                    <Icon name={props.icon} color={botoxColors.gray.dark} />
                </Flex>
                <Small>{props.activityStatus}</Small>
            </Flex>
            
            <FlexItem>
                <LinkButton variant={props.createNew ? "filled" : "outlined"} href={props.activityLink} text={props.activityTitle} icon={props.createNew ? 'add_circle' : 'arrows_chevron_chevronForward'} iconPosition='right'/>
            </FlexItem>
        </Flex>
    );
}